export default __webpack_public_path__ + "8195ae3f9fc8e675ea0a92919260c03e.png";